import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconHigharcGrey(props: SvgIconProps) {
  return (
    <SVGIcon width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 0V16H24.0006V0H0ZM2.66604 14.6664C2.66604 9.51109 6.84504 5.33333 11.9991 5.33333C17.1543 5.33333 21.3321 9.51233 21.3321 14.6664H2.66604Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
